import { LabelPosition } from '@capturum/builders/core';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { FormRendererState } from '../../state/form-renderer/form-renderer.state';

@Component({
  selector: 'cpb-default-input-wrapper',
  templateUrl: './default-input-wrapper.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./default-input-wrapper.component.scss'],
})
export class CapturumBuilderDefaultInputWrapperComponent extends FieldWrapper implements OnInit {
  public submitted: Observable<boolean>;
  public labelPosition: typeof LabelPosition = LabelPosition;

  constructor(private readonly store: Store) {
    super();
  }

  public ngOnInit(): void {
    this.submitted = this.store.select(FormRendererState.isSubmitted(this.to.formKey));
  }
}
